import {
  ROUTE_HOME,
  ROUTE_DISCLAIMER,
  ROUTE_NOT_FOUND,
  // ARTICLES
  ROUTE_AFFORDABLE_HOUSING,
  ROUTE_IMPACT_LITIGATION,
  ROUTE_HEALTHCARE_LITIGATION,
  ROUTE_ENVIRONMENTAL_LAW,
  ROUTE_SPORTS_LAW,
  ROUTE_CORPORATE,
  ROUTE_REAL_ESTATE,
  ROUTE_TAX_EXEMPT,
  ROUTE_ENTERTAINMENT,
  ROUTE_TAX_CREDIT_FINANCING,
} from "../routing/routes.js";

import ViewHome from "../views/Home.vue";
import ViewDisclaimer from "../views/Disclaimer.vue";
import ViewNotFound from "../views/NotFound.vue";
// ARTICLES
import ViewAffordableHousing from "../views/AffordableHousing.vue";
import ViewImpactLitigation from "../views/ImpactLitigation.vue";
import ViewHealthcareLitigation from "../views/HealthcareLitigation.vue";
import ViewEnvironmentalLaw from "../views/EnvironmentalLaw.vue";
import ViewSportsLaw from "../views/SportsLaw.vue";
import ViewCorporate from "../views/Corporate.vue";
import ViewRealEstate from "../views/RealEstate.vue";
import ViewTaxExempt from "../views/TaxExempt.vue";
import ViewEntertainment from "../views/Entertainment.vue";
import ViewTaxCreditFinancing from "../views/TaxCreditFinancing.vue";

import { truthy } from "../utils/index.js";
import LayoutHome from "../layouts/Home.vue";
import texts from "../texts.json";

const PATH_HOME = "";
const PATH_DISCLAIMER = `${PATH_HOME}/disclaimer`;
// ARTICLES
const PATH_AFFORDABLE_HOUSING = `${PATH_HOME}/affordable-housing`;
const PATH_IMPACT_LITIGATION = `${PATH_HOME}/impact-litigation`;
const PATH_HEALTHCARE_LITIGATION = `${PATH_HOME}/healthcare-litigation`;
const PATH_ENVIRONMENTAL_LAW = `${PATH_HOME}/environmental-law`;
const PATH_SPORTS_LAW = `${PATH_HOME}/sports-law`;
const PATH_CORPORATE = `${PATH_HOME}/corporate`;
const PATH_REAL_ESTATE = `${PATH_HOME}/real-estate`;
const PATH_TAX_EXEMPT = `${PATH_HOME}/tax-exempt-organizations`;
const PATH_ENTERTAINMENT = `${PATH_HOME}/entertainment-film-financing`;
const PATH_TAX_CREDIT_FINANCING = `${PATH_HOME}/tax-credit-financing`;

const addSiteTitle = (text) =>
  [text, texts.brand_name_short].filter(truthy).join(" - ");

export default [
  {
    path: PATH_HOME,
    name: ROUTE_HOME,
    component: ViewHome,
    meta: {
      title: addSiteTitle(),
      Layout: LayoutHome,
    },
  },
  {
    path: PATH_DISCLAIMER,
    name: ROUTE_DISCLAIMER,
    component: ViewDisclaimer,
    meta: {
      title: addSiteTitle("Disclaimer"),
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: ROUTE_NOT_FOUND,
    component: ViewNotFound,
    meta: {
      title: "Not Found",
    },
  },
  // ARTICLES
  {
    path: PATH_AFFORDABLE_HOUSING,
    name: ROUTE_AFFORDABLE_HOUSING,
    component: ViewAffordableHousing,
    meta: {
      title: addSiteTitle("Affordable Housing"),
    },
  },
  {
    path: PATH_IMPACT_LITIGATION,
    name: ROUTE_IMPACT_LITIGATION,
    component: ViewImpactLitigation,
    meta: {
      title: addSiteTitle("Impact Litigation"),
    },
  },
  {
    path: PATH_HEALTHCARE_LITIGATION,
    name: ROUTE_HEALTHCARE_LITIGATION,
    component: ViewHealthcareLitigation,
    meta: {
      title: addSiteTitle("Healthcare Litigation"),
    },
  },
  {
    path: PATH_ENVIRONMENTAL_LAW,
    name: ROUTE_ENVIRONMENTAL_LAW,
    component: ViewEnvironmentalLaw,
    meta: {
      title: addSiteTitle("Environmental Law"),
    },
  },
  {
    path: PATH_SPORTS_LAW,
    name: ROUTE_SPORTS_LAW,
    component: ViewSportsLaw,
    meta: {
      title: addSiteTitle("Sports Law"),
    },
  },
  {
    path: PATH_CORPORATE,
    name: ROUTE_CORPORATE,
    component: ViewCorporate,
    meta: {
      title: addSiteTitle("Corporate"),
    },
  },
  {
    path: PATH_REAL_ESTATE,
    name: ROUTE_REAL_ESTATE,
    component: ViewRealEstate,
    meta: {
      title: addSiteTitle("Real Estate"),
    },
  },
  {
    path: PATH_TAX_EXEMPT,
    name: ROUTE_TAX_EXEMPT,
    component: ViewTaxExempt,
    meta: {
      title: addSiteTitle("Tax-Exempt Organizations"),
    },
  },
  {
    path: PATH_ENTERTAINMENT,
    name: ROUTE_ENTERTAINMENT,
    component: ViewEntertainment,
    meta: {
      title: addSiteTitle("Entertainment + Film Financing"),
    },
  },
  {
    path: PATH_TAX_CREDIT_FINANCING,
    name: ROUTE_TAX_CREDIT_FINANCING,
    component: ViewTaxCreditFinancing,
    meta: {
      title: addSiteTitle("Tax Credit Financing"),
    },
  },
];
